import { z } from 'zod';
import { IsoTimestampSchema, UuidSchema } from './common';

export const IngestLogSchema = z.object({
  messageType: z.string().min(1).max(64),
  message: z.string().min(1).max(8000),
  timestamp: IsoTimestampSchema.optional(),
  metadata: z.record(z.unknown()).optional(),
});

export const IngestBatchSchema = z.object({
  logs: z.array(IngestLogSchema).min(1).max(500),
});

export const IngestResponseSchema = z.object({
  id: UuidSchema,
});

export const IngestBatchResponseSchema = z.object({
  ids: z.array(UuidSchema),
  rejected: z.array(
    z.object({
      index: z.number().int().nonnegative(),
      error: z.string(),
    }),
  ),
});

export type IngestLog = z.infer<typeof IngestLogSchema>;
export type IngestBatch = z.infer<typeof IngestBatchSchema>;
export type IngestResponse = z.infer<typeof IngestResponseSchema>;
export type IngestBatchResponse = z.infer<typeof IngestBatchResponseSchema>;
